import React from 'react';
import { PropTypes } from 'prop-types';
import ClientSummary from './ClientSummary';

const ClientsList = ({ clients, authToken }) => (
    <div className="project-list-container">
        {clients.map(client => (
            <ClientSummary client={client} key={client.id} authToken={authToken} />
        ))}
    </div>
);

ClientsList.propTypes = {
    clients: PropTypes.array,
    authToken: PropTypes.string.isRequired,
};

ClientsList.defaultProps = {
    clients: [],
};
export default ClientsList;



// WEBPACK FOOTER //
// ./src/containers/ClientsList/ClientsList.js